import { render, staticRenderFns } from "./dx_store.vue?vue&type=template&id=2969d6da&scoped=true&"
import script from "./dx_store.vue?vue&type=script&lang=js&"
export * from "./dx_store.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2969d6da",
  null
  
)

component.options.__file = "dx_store.vue"
export default component.exports